module.exports = __webpack_public_path__ + "img/cnaas.297d9bda.jpg";